import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import ProductsHero from "./components/ProductsHero";
import ProductsGrid from "./components/ProductsGrid";
import ProductsCTA from "./components/ProductsCTA";

export default function ProductsPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeCategory, setActiveCategory] = useState(
    searchParams.get("category") || "all"
  );

  useEffect(() => {
    const cat = searchParams.get("category") || "all";
    setActiveCategory(cat);
  }, [searchParams]);

  const handleCategoryChange = (id: string) => {
    setActiveCategory(id);
    if (id === "all") {
      setSearchParams({});
    } else {
      setSearchParams({ category: id });
    }
    // Smooth scroll to grid
    setTimeout(() => {
      const el = document.getElementById("products-grid-section");
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 100);
  };

  return (
    <main className="min-h-screen bg-white">
      <SiteHeader />
      <ProductsHero
        activeCategory={activeCategory}
        onCategoryChange={handleCategoryChange}
      />
      <div id="products-grid-section">
        <ProductsGrid activeCategory={activeCategory} />
      </div>
      <ProductsCTA />
      <SiteFooter />
    </main>
  );
}
